export const block = (state) => state.block?.blockHeight;
export const blockAutoRefresh = (state) => state.block.autoRefresh;
export const blockShowCarousel = (state) => state.block.showCarousel;
